import React from 'react';
import { Button, MenuItem, Box, Modal, FormLabel, Select, FormControl, TextField } from '@mui/material';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Typography from '@mui/material/Typography';
import Iconify from '../../iconify';

function Index(props) {
  const { check, handleCheckClose, state, data, handleChange, handleFinish } = props;

  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const steps = [
    {
      label: 'Verify Aadhar',
      description: `verify your aadhar`,
    },
    {
      label: 'Verify Pan',
      description: `verify your pan`,
    },
    {
      label: 'Verify Profile',
      description: `verify your profile`,
    },
  ];

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    maxHeight: 600,
    minHeight: 600,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
  };

  const closeModel = ()=>{
    setActiveStep(0)
    handleCheckClose()
  }
  
  const handleSubmit = () =>{
    setActiveStep(0)
    handleFinish()
  }

  return (
    <div>
      <Modal
        open={check}
        onClose={closeModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ margin: '10px' }}>Edit User Details</div>
            <Iconify style={{ cursor: 'pointer' }} onClick={handleCheckClose} icon={'material-symbols:close'} />
          </div>

          <Stepper activeStep={activeStep}>
            {steps.map((step, index) => (
              <Step key={step.label}>
                <StepLabel>{step.label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mt: '50px',
            }}
          >
            <div>
              {activeStep === 0 && (
                <FormControl size="small">
                  <div>Aadhar No. : {data?.userInfo?.[data?.userInfo?.length - 1]?.AdharCard}</div>
                  <Typography style={{ marginTop: '10px' }}>
                    Status <span style={{ color: 'red' }}>*</span> :
                  </Typography>
                  <Select
                    disabled={data?.kycreason?.Aadhar === 'verified'}
                    name="Aadhar"
                    onChange={handleChange}
                    value={state?.Aadhar}
                  >
                    <MenuItem value="verified">Verified</MenuItem>
                    <MenuItem value="inprogress">In Progress</MenuItem>
                    <MenuItem value="failure">Failure</MenuItem>
                  </Select>

                  {data?.kycreason?.Aadhar === 'failure' ||
                    (state?.Aadhar === 'failure' && (
                      <>
                        <Typography style={{ marginTop: '10px' }}>Reason(optional) : </Typography>
                        <TextField
                          name="AadharReason"
                          value={state?.AadharReason ?? ''}
                          onChange={handleChange}
                          size="small"
                          placeholder="Enter Reason"
                        />
                      </>
                    ))}
                  <div
                    style={{
                      display: 'flex',
                      gap: '10px',
                      justifyContent: 'center',
                      marginTop: '20px',
                    }}
                  >
                    <Button
                      disabled={state?.Aadhar !== 'verified'}
                      style={state?.Aadhar === 'verified'?{ backgroundColor: '#2065D1', color: 'white' }:{}}
                      onClick={handleNext}
                    >
                      Next
                    </Button>
                  </div>
                </FormControl>
              )}
              {activeStep === 1 && (
                <FormControl size="small">
                  <img
                    style={{
                      width: '100px',
                      height: '100px',
                      margin: 'auto',
                      marginBottom: '10px',
                      borderRadius: '10px',
                    }}
                    alt="pancard"
                    src={data?.pancardUrl}
                  />
                  <Typography style={{ marginTop: '10px' }}>
                    Status <span style={{ color: 'red' }}>*</span> :
                  </Typography>
                  <Select
                    disabled={data?.kycreason?.Pan === 'verified'}
                    name="Pan"
                    onChange={handleChange}
                    defaultValue="failure"
                    value={state?.Pan}
                  >
                    <MenuItem value="verified">Verified</MenuItem>
                    <MenuItem value="inprogress">In Progress</MenuItem>
                    <MenuItem value="failure">Failure</MenuItem>
                  </Select>

                  <Typography style={{ marginTop: '10px' }}>PanNumber : </Typography>
                  <TextField
                    name="PanNumber"
                    // value={state?.ProfileReason ?? ''}
                    onChange={handleChange}
                    size="small"
                    placeholder="Enter pan number"
                  />
                  {
                    (state?.Pan === 'failure' && (
                      <>
                        <Typography style={{ marginTop: '10px' }}>Reason(optional) : </Typography>
                        <TextField
                          name="PanReason"
                          value={state?.PanReason ?? ''}
                          onChange={handleChange}
                          size="small"
                          placeholder="Enter Reason"
                        />
                      </>
                    ))}
                  <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '20px' }}>
                    <Button
                      disabled={activeStep === 0}
                      style={{ backgroundColor: '#2065D1', color: 'white' }}
                      onClick={handleBack}
                    >
                      Back
                    </Button>
                    {/* {(data?.kycreason?.Pan === 'failure' ||
                      data?.kycreason?.Pan === 'inprogress' ||
                      state?.Pan === 'failure' ||
                      state?.Pan === 'inprogress') && (
                      <> */}
                        <Button
                          disabled={state?.Pan !== 'verified'}
                          style={state?.Pan === 'verified'?{ backgroundColor: '#2065D1', color: 'white' }:{}}
                          onClick={handleNext}
                        >
                          Next
                        </Button>
                      {/* </>
                    )} */}
                  </div>
                </FormControl>
              )}
              {activeStep === 2 && (
                <FormControl size="small">
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <Box>
                      <FormLabel>Image :</FormLabel>
                      <img
                        style={{
                          width: '100px',
                          height: '100px',
                          margin: 'auto',
                          marginBottom: '10px',
                          borderRadius: '10px',
                        }}
                        alt="Profile"
                        src={data?.imageUrl}
                      />
                    </Box>
                    <Box>
                      <FormLabel>Pan :</FormLabel>
                      <img
                        style={{
                          width: '100px',
                          height: '100px',
                          margin: 'auto',
                          marginBottom: '10px',
                          borderRadius: '10px',
                        }}
                        alt="Profile"
                        src={data?.pancardUrl}
                      />
                    </Box>
                  </Box>
                  <Typography style={{ marginTop: '10px' }}>
                    Status <span style={{ color: 'red' }}>*</span> :
                  </Typography>
                  <Select
                    disabled={data?.kycreason?.Profile === 'verified'}
                    name="Profile"
                    onChange={handleChange}
                    value={state?.Profile}
                  >
                    <MenuItem value="verified">Verified</MenuItem>
                    <MenuItem value="inprogress">In Progress</MenuItem>
                    <MenuItem value="failure">Failure</MenuItem>
                  </Select>

                  {
                    (state?.Profile === 'failure' && (
                      <>
                        <Typography style={{ marginTop: '10px' }}>Reason(optional) : </Typography>
                        <TextField
                          name="ProfileReason"
                          value={state?.ProfileReason ?? ''}
                          onChange={handleChange}
                          size="small"
                          placeholder="Enter Reason"
                        />
                      </>
                    ))}
                  <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '20px' }}>
                    <Button
                      disabled={activeStep === 0}
                      style={{ backgroundColor: '#2065D1', color: 'white' }}
                      onClick={handleBack}
                    >
                      Back
                    </Button>
                    <Button 
                      disabled={state?.Profile !== 'verified'}
                      style={state?.Profile === 'verified'?{ backgroundColor: '#2065D1', color: 'white' }:{}}
                      onClick={handleSubmit}
                    >
                      Finish
                    </Button>
                  </div>
                </FormControl>
              )}
            </div>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default Index;
